import type { AuthoringStatus, MeResponse } from "@keydials/api-client";
import { kioskNav } from "../lib/kiosk";

/**
 * Whether to offer the dial builder at all (KEY-560). Every way in and the `/build` route itself ask this, and it fails closed:
 * no answer from the server yet, a failed probe, or anything else unclear means no builder.
 * <para>
 * `selfService` rather than `enabled`: the status probe says `enabled` to platform staff too, but a dial they started here would
 * be a catalogue draft that could never go live. A shared device (a PIN or guest session) and an ended trial never reach it, and
 * neither does anyone who can't build dials in the organisation they signed in to.
 * </para>
 * Not a security boundary: the server refuses every authoring route on its own. This only stops the app offering a door it knows
 * is locked.
 */
export interface BuilderGateInput {
  status: AuthoringStatus | null;
  me: Pick<MeResponse, "capabilities" | "trialExpired" | "pinnedToInstanceId" | "guestInstanceId"> | null;
}

export function offerBuilder({ status, me }: BuilderGateInput): boolean {
  if (!status || !me) return false;
  if (status.enabled !== true || status.selfService !== true) return false;
  if (me.trialExpired) return false;
  if (kioskNav(me).locked) return false;
  return me.capabilities.includes("dial.author");
}
